import { render, staticRenderFns } from "./DoubleNavigation.vue?vue&type=template&id=765f3f72&scoped=true"
import script from "./DoubleNavigation.vue?vue&type=script&lang=js"
export * from "./DoubleNavigation.vue?vue&type=script&lang=js"
import style0 from "./common/style.scss?vue&type=style&index=0&id=765f3f72&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765f3f72",
  null
  
)

export default component.exports